import { FormattedMessage } from 'react-intl';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { EditTargetsContent } from './edit-targets-content';

interface EditTargetsDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function EditTargetsDialog({
  isOpen,
  setIsOpen,
}: EditTargetsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage defaultMessage="Edit Targets" />
          </DialogTitle>
        </DialogHeader>

        <EditTargetsContent />
      </DialogContent>
    </Dialog>
  );
}
